<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Duomenų valdymas') }}</h1>
    <v-row>
      <v-col
        style="min-width: 20rem !important"
        v-for="(application, index) in applications"
        v-show="application.parameter_key != 'ireg'"
        :key="index"
        cols="12"
        md="3"
      >
        <v-card outlined  class="mb-4">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="text-h5 mb-1">
                <span>{{
                  getApplicationTitle(application.parameter_key)
                }}</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span
                  >{{ $t('Būsena:')
                  }}<strong>{{
                    application.parameter_value
                      ? $t('Aktyvus')
                      : $t('Neaktyvus')
                  }}</strong></span
                ></v-list-item-subtitle
              >
            </v-list-item-content>
            <v-list-item-action>
              <el-button
                :color="application.parameter_value ? 'danger' : 'primary'"
                :title="
                  application.parameter_value ? $t('Išjungti') : $t('Įjungti')
                "
                :loading="loading"
                @click.native="switchApi(application)"
              />
            </v-list-item-action>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <!-- audit -->
    <admin-audits-data/>
  </v-container>
</template>

<script>
import AdminAuditsData from './components/AdminAuditsData.vue'
import userRole from '@/mixins/userRole'
import { mapGetters } from 'vuex'
import math from '@/mixins/math'

export default {
  name: 'AdminData',
  components: {
    AdminAuditsData,
  },
  mixins: [userRole, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showLog: false,
      modalLogItem: {},
      modalDeleteVardas: '',
      modalDeleteItem: null,
      listData: [],
      searchData: {},
      applications: [
        {
          title: 'BROKER API',
          key: 'broker',
          active: true,
        },
        {
          title: 'NIRVAR periodinis tikrinimas',
          key: 'nirvar',
          active: true,
        },
        {
          title: 'ILTU kodo gavimas iš RC ASMENYS',
          key: 'check_iltu',
          active: true,
        },
      ],
    }
  },
  created() {
    this.getApi()
  },
  methods: {
    getApplicationTitle(key) {
      if (key == 'broker') {
        return 'BROKER API';
      } else if (key == 'nirvar') {
        return 'NIRVAR periodinis tikrinimas'
      } else if (key == 'check_iltu') {
        return 'ILTU kodo gavimas iš RC ASMENYS'
      }
    },
    switchApi(application) {
      let logic = !application.parameter_value
      this.$set(application, 'parameter_value', logic)
      let data = application
       this.paginationloading = true
      this.$axios
        .post(`api-controls`,data)
        .then((res) => {
          this.getApi()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.paginationloading = false
        })
    },
    getApi() {
      this.loading = true
      this.pageloading = true
      this.$axios
        .post(`api-controls/list`)
        .then((res) => {
          this.applications = res.data.apiControls
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
